import Component from './component';

export default class Navbar extends Component {
  constructor() {
    super('navbar', null, 'navbar-dark');
  }
}